import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router"
import { TripsService } from '../../services/trips.service';
import { SchedulesService } from '../../services/schedules.service';
import { Trip } from 'src/app/interfaces/trip';

@Component({
  selector: 'app-trip-detail',
  templateUrl: './trip-detail.component.html',
  styleUrls: ['./trip-detail.component.css']
})
export class TripDetailComponent implements OnInit {

  public trips: any[] = [];
  public schedules: any[] = [];
  private selected_trip: string;

  constructor(private tripsService: TripsService, private schedulesService: SchedulesService, private route: ActivatedRoute) {
    if(this.route.snapshot.paramMap.get('block') != ""){
      this.selected_trip = this.route.snapshot.paramMap.get('block')
    }
   }

  ngOnInit(): void {
    this.getTrips();
    this.getSchedule(this.selected_trip);
  }

  getTrips(): void {
    this.tripsService.get(this.selected_trip)
        .subscribe(trips => this.trips = trips);
  }

  getSchedule(block: string): void {
    this.schedulesService.get(block)
        .subscribe(schedules => this.schedules = schedules);
  }
} 
